// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.contract-container[data-v-380ed0af] {\n  color: black;\n  font-family: Lato, Avenir, Helvetica, Arial, sans-serif;\n  margin: 1em auto;\n  padding: 0 1em;\n  text-align: left;\n}\n.contract-container a[data-v-380ed0af] {\n  color: black !important;\n}\n", ""]);
// Exports
module.exports = exports;
